import { Outlet } from 'react-router-dom'
import { Header } from '@/app/components/Header'
import { Footer } from '@/app/components/Footer'

/**
 * ErrorLayout.tsx
 * Shell for public error pages (/access_denied, /Unauthorized).
 * Renders Header + Footer without the Sidebar or ProtectedRoute guard.
 */
export function ErrorLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-gray-50">
      <Header />
      <main className="flex flex-1 flex-col overflow-y-auto pt-12">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
